/**
 * Helper pour accéder aux variables d'environnement
 * Compatible avec Jest (process.env) et Vite (import.meta.env)
 */

/**
 * Obtient une variable d'environnement
 * @param key - Clé de la variable d'environnement
 * @param defaultValue - Valeur par défaut si non trouvée
 */
export function getEnv(key: string, defaultValue: string = ''): string {
  // Priorité 1: import.meta.env (Vite/Browser) — remplacé statiquement au build
  try {
    // Vite remplace `import.meta.env` à la compilation. En Jest/Node hors Vite,
    // ce bloc throw silencieusement et on tombe sur process.env.
    const env = (import.meta as ImportMeta & { env?: Record<string, string> }).env;
    if (env && env[key] !== undefined && env[key] !== '') {
      return env[key] ?? defaultValue;
    }
  } catch {
    // import.meta non disponible (Jest CJS), on continue.
  }

  // Priorité 2: process.env (Jest/Node.js)
  if (typeof process !== 'undefined' && process.env && process.env[key]) {
    return process.env[key] || defaultValue;
  }

  return defaultValue;
}

/**
 * Vérifie si on est en mode développement
 */
export function isDev(): boolean {
  if (typeof process !== 'undefined' && process.env) {
    return process.env.NODE_ENV !== 'production' && process.env.DEV === 'true';
  }
  return getEnv('DEV', 'true') === 'true';
}

/**
 * Vérifie si on est en mode production
 */
export function isProd(): boolean {
  if (typeof process !== 'undefined' && process.env) {
    return process.env.NODE_ENV === 'production' || process.env.PROD === 'true';
  }
  return getEnv('PROD', 'false') === 'true';
}
